/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["pdf-preview{display:block;width:100%;height:100%;margin:auto;position:absolute;top:0;left:0;right:0;bottom:0}pdf-preview object{width:100%;height:100%;border:none}"];
export { styles as styles };
